// extracted by mini-css-extract-plugin
export default {"item":"CardCarousel_item__zCpOm","dot-list":"CardCarousel_dot-list__QRZW5","container":"CardCarousel_container__Y1WRz"};